import moment from 'moment'

/**
 * Checks if the given parameter is a valid moment date
 *
 * @param {Moment} date
 */
export function isValidDate (date) {
  return moment(date || null).isValid()
}



// WEBPACK FOOTER //
// ./src/utils/moment.js